"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateRules = exports.generateErrorMsg = void 0;
var _lodash = require("lodash");
var _constants = require("../../constants");
const validateRules = (field, value, rules) => {
  let errors = {};
  if (rules.required && (0, _lodash.isEmpty)(value.trim())) {
    errors[field] = {
      getMessage: () => rules.required?.message
    };
  }
  if (rules.maxLength && value.length > _constants.NAME_MAX_LENGTH) {
    errors[field] = {
      getMessage: () => rules.maxLength?.message
    };
  }
  return errors;
};
exports.validateRules = validateRules;
const generateErrorMsg = (name, errors) => {
  const errorMsg = errors[name]?.getMessage();
  return errorMsg || '';
};
exports.generateErrorMsg = generateErrorMsg;